/**
 * Validates if a quotation is ready for Yappy payment processing
 *
 * @param {Object} quoteData - Quote header data
 * @returns {Object} Validation result with isValid flag and error messages
 */
export const validateQuoteForYappyPayment = quoteData => {
  const errors = []

  // Validate amount
  if (!quoteData.AmountWithTax || quoteData.AmountWithTax <= 0) {
    errors.push('El monto debe ser mayor a cero')
  }

  // Validate products
  if (!quoteData.Lines || quoteData.Lines.length === 0) {
    errors.push('La cotización debe tener al menos un producto')
  }

  // Validate customer name
  if (
    !quoteData.CustomerNameDocument ||
    quoteData.CustomerNameDocument.trim() === ''
  ) {
    errors.push('Se requiere nombre del cliente')
  }

  return {
    isValid: errors.length === 0,
    errors,
  }
}

/**
 * Checks if a payment is confirmed
 *
 * @param {Object} quoteData - Quote header data
 * @returns {boolean} True if payment is confirmed
 */
export const isPaymentConfirmed = quoteData => {
  return quoteData?.PaymentStatus === 'confirmed'
}
